import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import cx from 'clsx';
import { Footer as FooterType, Country } from '../../util/types';
import classes from './Footer.module.scss';

const Text = dynamic(() => import('../../common/Text/Text'));
const Container = dynamic(() => import('../../common/Container/Container'));
const FooterColumn = dynamic(() => import('./FooterColumn/FooterColumn'));
const Social = dynamic(() => import('./Social/Social'));
const Image = dynamic(() => import('next/image'));
const Link = dynamic(() => import('next/link'));

const default_logo = 'https://storagy-advent-core-ppr.s3.amazonaws.com/storage/c5e87749-0bef-4594-8422-94324792344d.svg';

export interface FooterProps extends React.HTMLProps<HTMLDivElement> {
  footer?: FooterType;
  country_list: Country[],
  countryCode?: string,
}

export default function Footer({
  className,
  footer,
  country_list,
  countryCode,
  ...others
}: FooterProps) {
  const [innerWidth, setInnerWidth] = useState(0);
  const [email, setEmail] = useState('');

  const subscribe = () => {

  };

  const resize = () => {
    setInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    if (window) {
      setInnerWidth(window.innerWidth);
      window.addEventListener('resize', resize);
    }

    return () => {
      if (window) {
        window.removeEventListener('resize', resize);
      }
    };
  });

  const secondaryColumns = ([
    // <CountryColumn
    //   key={0}
    //   innerWidth={innerWidth}
    //   className={cx(classes.column, classes.country, classes.secondary)}
    //   choose_country={footer?.choose_country}
    //   countryCode={countryCode}
    //   country_list={country_list}
    //   social_media={footer?.social_media}
    // />,
    <FooterColumn
      key={1}
      className={cx(classes.column, classes.secondary)}
      title={footer?.member_links}
      links={footer?.member_links_elements}
    />,
    <FooterColumn
      key={2}
      className={cx(classes.column, classes.secondary)}
      title={footer?.support}
      links={footer?.support_elements}
    />,
    <FooterColumn
      key={3}
      className={cx(classes.column, classes.secondary)}
      title={footer?.company}
      links={footer?.company_elements}
    />,
  ]);

  return (
    <footer className={cx(className, classes.footer)} {...others}>
      <Container className={classes.innerContainer}>
        <div className={cx(classes.column, classes.mainColumn)}>
          <Link href="/" passHref>
            <a className={classes.logo}>
              <Image
                className={classes.logoImage}
                src={footer?.logo?.fields.file.url ?
                  footer?.logo?.fields.file.url.slice(0, 2) === '//' ?
                    `https:${footer?.logo?.fields.file.url}` : footer?.logo?.fields.file.url :
                  default_logo
                }
                loading="lazy"
                placeholder="empty"
                alt="logo"
                style={{ objectFit: 'contain' }}
                width={footer?.logo?.fields.file.details.image.width}
                height={footer?.logo?.fields.file.details.image.height}
              />
            </a>
          </Link>
          {/*<div className={classes.subscribe}>*/}
          {/*  <input className={classes.subscribeInput} placeholder={footer?.enter_email_placeholder} />*/}
          {/*  <Button className={classes.subscribeButton} onClick={subscribe} aria-label={footer?.enter_email_placeholder}>*/}
          {/*    <FaIcon icon={faArrowRight} />*/}
          {/*  </Button>*/}
          {/*</div>*/}
          <Text className={classes.copyright}>
            {footer?.copyright.replace('%year%', new Date().getFullYear().toString())}
          </Text>
        </div>
        {innerWidth === 0 || innerWidth > 1049 ? (
          secondaryColumns.map(item => item)
        ) : (
          <div className={classes.secondaryColumns}>
            {secondaryColumns.map(item => item)}
          </div>
        )}
        <div className={classes.socialContainer}>
          <Social {...footer?.social_media} innerWidth={innerWidth}/>
        </div>
      </Container>
    </footer>
  );
}

Footer.displayName = '@ioa/lablocator/Footer';
